import { PageHero } from "../components/PageHero";
import { CTABand } from "../components/CTABand";
import { FadeUp, Ribbon } from "../components/Reveal";
import { useContent, imgSrc } from "../context/ContentContext";
import { images } from "../config/siteConfig";

export default function OverMij() {
  const { site, pages } = useContent();
  const t = pages.overMij;
  return (
    <main data-testid="over-mij-page">
      <PageHero eyebrow="Over mij" title={t.title} intro={t.intro} />

      <section className="bg-white">
        <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-12 sm:px-6 lg:grid-cols-3">
          <FadeUp>
            <div className="relative pb-4">
              <img
                src={imgSrc(site.portraitImage || images.portrait.src)}
                alt={images.portrait.alt}
                className="aspect-[4/5] w-full object-cover object-top"
                loading="lazy"
              />
              <Ribbon className="absolute -bottom-0 left-4">Aan het werk</Ribbon>
            </div>
          </FadeUp>

          <div className="lg:col-span-2">
            <FadeUp>
              <h2 className="font-display text-2xl font-bold uppercase tracking-wide text-[#111111]">{t.heading}</h2>
            </FadeUp>
            <FadeUp delay={0.05}>
              <p className="mt-4 text-[15px] leading-relaxed text-[#555555]">{t.text1}</p>
            </FadeUp>
            <FadeUp delay={0.1}>
              <p className="mt-4 text-[15px] leading-relaxed text-[#555555]">{t.text2}</p>
            </FadeUp>

            <div className="mt-10">
              {t.facts.map((f, i) => (
                <FadeUp key={f.label} delay={0.05 * i}>
                  <div
                    data-testid={`over-mij-fact-${i}`}
                    className="flex flex-col gap-1 border-b border-[#E2E0D9] py-4 sm:flex-row sm:items-baseline sm:gap-6"
                  >
                    <p className="w-40 shrink-0 font-display text-sm font-bold uppercase tracking-wide text-[#8E8D8A]">{f.label}</p>
                    <p className="text-[15px] text-[#333333]">{f.value}</p>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#EFEDE8]">
        <div className="mx-auto max-w-[1400px] px-4 py-12 sm:px-6">
          <FadeUp>
            <h2 className="font-display text-2xl font-bold uppercase tracking-wide text-[#111111] sm:text-3xl">{t.stepsTitle}</h2>
          </FadeUp>
          <div className="mt-8 grid gap-6 sm:grid-cols-3">
            {t.steps.map((step, i) => (
              <FadeUp key={step.title} delay={i * 0.08}>
                <div data-testid={`werkwijze-step-${i}`} className="border border-[#DDD9D0] bg-white p-6">
                  <span className="font-display text-2xl font-bold text-[#B9B7B0]">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="mt-3 font-display text-lg font-bold uppercase tracking-wide text-[#111111]">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#555555]">{step.text}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <CTABand
        title="Kennismaken?"
        text="Bel of mail gerust, of laat je gegevens achter via het formulier. Ik neem zo snel mogelijk contact met je op."
      />
    </main>
  );
}
